import styled from 'styled-components';
import { Images } from '@/assets';
import { fonts } from '@/theme/fonts';
import LanguageButtons from './LanguageButtons';

const Header = () => {
  return (
    <Container>
      <LogoWrap>
        <Logo src={Images.Logo} alt="r2-playground-logo" />
        <Title>
          R2Playground
          <br />
          Partner Home
        </Title>
      </LogoWrap>
      <LanguageButtons />
    </Container>
  );
};

export default Header;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 90px;
  padding-left: 24px;
`;

const LogoWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Logo = styled.img`
  width: 50px;
  height: 50px;
`;

const Title = styled.div`
  font-weight: ${fonts.weight.bold};
  font-size: 20px;
  line-height: 101%;
  color: #8ca2f4;
`;
